export default {
    aggregateChart: {
        forecastFutures: 'prognoza + futures',
        futuresOnly: 'samo futures',
        finalPosition: 'Konačna pozicija',
        netPositionAxis: 'Neto pozicija (MWh)  ·  + KRATKA  /  − DUGA',
        short: 'KRATKA',
        long: 'DUGA',
        flat: 'neutralno',
        hrForecast: 'HR · prognoza',
        hrFutures: 'HR · futures',
        siForecast: 'SI · prognoza',
        siFutures: 'SI · futures',
        ariaLabel: 'Agregatni grafikon složenih pozicija između ugovora, {country}',
        allCountries: 'sve države',
        noForecastNotePre: 'Nema prognoze za ovaj raspon — pojasevi prikazuju',
        noForecastNoteRest:
            '(osnovna prognoza je nula). Nakon što se prognoza obradi, pojavit će se ovdje.',
        signPre: 'Neto pozicija —',
        signAbove: 'iznad 0 = KRATKA',
        signAboveDesc: '(nedovoljno nabavljeno, kupite više) ·',
        signBelow: 'ispod 0 = DUGA',
        signBelowDesc:
            '(previše nabavljeno, višak za prodaju). Kupnja nadoknađuje potražnju, pa pomiče liniju prema dolje.',
    },
}
